import { IDocumentService, IWindowService } from "angular";

export class ClearViewUtils {
    public static getSharedService<T extends new(...args: any[]) => any>(service: T, serviceName: string) {
        if (!window['ClearViewSharedServices'])
            window['ClearViewSharedServices'] = {};
        if (!window['ClearViewSharedServices'][serviceName])
            window['ClearViewSharedServices'][serviceName] = new service();

        return window['ClearViewSharedServices'][serviceName];
    }

    /**
     * Promise wrapping setTimeout()
     */
    public static timeout(milliseconds: number) {
        return new Promise(resolve => window.setTimeout(resolve, milliseconds));
    }

    public static joinWithMax(arr: string[], max: number, separator: string = ',', totalValues: number = arr.length) {
        let displayString = '';
        let numberJoined = 0;
        while (displayString.length < max && numberJoined < arr.length) {
            const item = arr[numberJoined];
            if (Math.min(item.length, max) + displayString.length > max) // this name will push us over, just stop here
                break;

            displayString += item.substr(0, 15);
            numberJoined++;

            if (displayString.length < max && numberJoined < arr.length)
                displayString += separator;
        }

        if (arr.length > numberJoined)
            return `${displayString} ... (${totalValues - numberJoined} More)`;
        else
            return displayString;
    }

    public static joinStringsWithMax(arr: string[] | string, max: number, separator: string = ',', totalValues: number = arr.length) {
        if(typeof arr === 'string') return arr;
        let numberJoined = 0;
        const displayString = arr.reduce((acc, item) => {
            const newLength = acc.length + item.length + separator.length;
            if (newLength <= max) {
                numberJoined++;
                return acc + (acc.length > 0 ? separator + ' ' : '') + item;
            }
            return acc;
        }, '');

        if (arr.length > numberJoined)
            return `${displayString} ...`;
        else
            return displayString;
    }

    /**
     * Capitalizes the first letter of every word in a string and removes special characters
     * @param str will not function unless string has spaces between words
     * @returns string with first letter of every new word capitalized
     */
    public static capitalizeWords(str: string) {
        return str.replace(/\b\w/g, l => l.toUpperCase());
    }

    /**
     * Removes special characters from a string NOTE: _ is not removed
     * @param str string to remove special characters from
     * @returns string with special characters removed
     */
    public static removeSpecialCharacters(str: string) {
        return str.replace(/[^\w\s]/gi, '');
    }
}
